import * as yup from "yup";

export const schema = ({ formConfig }) => {
    const yupObject = {};
    Object.keys(formConfig).forEach((key) => {
        const required = formConfig[key].registerOptions.required;
        if (key === "email") {
            yupObject[key] = yup.mixed()
                .test("email", required.message, value => !checkIfValueEmpty(value)
                )
                .test("email", required.valid_email_message , value => validateEmail(value)
                )
        }
        else if (key === "original_image") {
            yupObject[key] = yup
                .mixed()
                .test(
                    "fileEmpty",
                    required.message,
                    files =>
                        !files ||
                        files.length > 0
                )
            // .test("fileSize", "Maximum upload size 50MB", (value) => {
            //     const file = value
            //     return file && file[0]?.size < 52428800;
            // })
        }
        else if (key === "consent") {
            yupObject[key] = yup.mixed()
                .test("accepted", required.message, (value) => {
                    return value && value === "I accept the terms and conditions"
                })
        }
        else {
            if (required.value) {
                yupObject[key] = yup.string().trim().required(required.message);
            } else {
                yupObject[key] = yup.string().trim();
            }
        }

    });
    yupObject["placid_uuid"] = yup.string().trim().required("Please select a card template");
    return yup.object(yupObject).required();
}

function checkIfValueEmpty(value) {
    return value === undefined || value === "";
}

function validateEmail(email) {
    if (email === undefined) return false;
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
}